import { useState } from 'react';
import CloseActionButton from '../../../components/kit/action-button/CloseActionButton';
import Logo from '../../../components/kit/logo/Logo';
import Text from '../../../components/kit/text/Text';
import styles from './DigitalConsent.module.css';
import StyledCheckbox from '../../../components/kit/checkbox/Checkbox';
import Button from '../../../components/kit/button/Button';

type DigitalConsentProps = {
  isVisible: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const DigitalConsent = ({
  isVisible,
  onClose,
  onContinue,
}: DigitalConsentProps) => {
  const [isAgeConfirmed, setIsAgeConfirmed] = useState(false);
  const [isPrescriptionConfirmed, setIsPrescriptionConfirmed] = useState(false);

  const onAgeConfirmationToggle = () => setIsAgeConfirmed((prev) => !prev);
  const onPrescriptionConfirmationToggle = () =>
    setIsPrescriptionConfirmed((prev) => !prev);

  return (
    <div className={isVisible ? styles.wrapper : styles.hidden}>
      <div className={styles.close}>
        <CloseActionButton onClose={onClose} color='white' />
      </div>
      <div className={styles.main}>
        <div className={styles['header-wrapper']}>
          <div className={styles.header}>
            <Logo
              type='white'
              style={{
                position: 'relative',
                top: '-57px',
                right: '-10px',
                width: '193px',
              }}
            />
          </div>
        </div>
        <div className={styles.content}>
          <div>
            <Text weight='bold' size='x-large' tag='h1'>
              Vydura complete experience
            </Text>
            <Text size='m-small'>
              By choosing to proceed, you agree that you:
            </Text>
            <div className={styles.checkbox}>
              <StyledCheckbox
                checked={isAgeConfirmed}
                onCheck={onAgeConfirmationToggle}
                label='Are at least 18 years of age'
              />
            </div>
            <div className={styles.checkbox}>
              <StyledCheckbox
                checked={isPrescriptionConfirmed}
                onCheck={onPrescriptionConfirmationToggle}
                label='Have a Vydura prescription'
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Button
          type='primary'
          width='full-width'
          onClick={onContinue}
          isReadOnly={!(isPrescriptionConfirmed && isAgeConfirmed)}
        >
          Join Vydura Buddy
        </Button>
      </div>
    </div>
  );
};

export default DigitalConsent;
